document.addEventListener("DOMContentLoaded", function () {
	external_link_whitelist.push(window.location.host);

	if (external_link_modal_content) {
		external_link_warning_text = Object.values(external_link_modal_content).join("\n\n");
	} else {
		external_link_warning_text = "You are leaving this website.";
	}

	document.querySelectorAll("a[href^='http']:not([href*='" + window.location.host + "']").forEach(function (link) {
		if (link.matches(".external-link-modal a")) {
			// Ignore links inside the modal
			return;
		}

		try {
			// The embed from TimeValueCalculators.com overwrites the global URL function
			// It is redefined to URLConstructor in the <head>, but this checks to make sure and then tries the native one as a fallback
			if (typeof URLConstructor === "function") {
				var url = new URLConstructor(link.href);
			} else {
				var url = new URL(link.href);
			}

			if (external_link_whitelist.includes(url.host)) {
				// Ignore whitelisted domains
				return;
			}

			link.addEventListener("click", function (event) {
				event.preventDefault();

				if (typeof HTMLDialogElement === "function") {
					// show nicer prompt for modern browsers that support <dialog>
					const externalLinkModal = document.querySelector(".external-link-modal");
					const externalLinkModalContinueButton = externalLinkModal.querySelector("a.continue-button");

					externalLinkModalContinueButton.setAttribute("href", link.href);
					externalLinkModalContinueButton.addEventListener("click", function (event) {
						externalLinkModal.close();
					});

					externalLinkModal.showModal();
				} else {
					// fallback using confirm() for older browsers
					if (window.confirm(external_link_warning_text)) {
						window.open(link.href);
					}
				}
			});
		} catch (error) {
			console.log(link);
			console.error(error);

			return;
		}
	});
});
